// Permissive phone-number plausibility check for the AM profile field
// (Settings → My Profile). Deliberately flexible: AMs may store an AU mobile
// ("0412 345 678"), an AU landline with area code ("(02) 9876 5432"), or an
// international number ("+64 21 555 0000"). We are NOT normalising or dialling
// these -- the phone is display-only in the email signature -- so the bar is
// "looks like a phone number a human typed", not "is reachable".
//
// Rules: an optional leading '+', then at least 6 and at most 30 characters
// drawn from digits, spaces, hyphens, dots, and parentheses. Must contain at
// least 6 actual digits (so "()- ." alone is rejected). Empty / whitespace is
// handled by the caller (it maps to "no phone"), not here.

const ALLOWED = /^\+?[\d\s().-]{6,30}$/;

export function isPlausiblePhoneNumber(raw: string): boolean {
  const value = raw.trim();
  if (!ALLOWED.test(value)) return false;
  const digitCount = (value.match(/\d/g) ?? []).length;
  return digitCount >= 6;
}
